import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useClientLinks } from "@/features/clients/hooks/use-scoped-client";
import { CallsTable } from "@/views/backoffice/calls/components/calls-table";
import { ArrowRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { useTranslation } from "@/features/utils/i18n";

export function LastCalls() {
  const { t } = useTranslation("dashboard");
  const links = useClientLinks();
  return (
    <Card className="flex-1">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle>{t("recentSessions.title")}</CardTitle>
          <Link
            to={links.calls()}
            className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1"
          >
            {t("recentSessions.viewAll")}
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </CardHeader>
      <CardContent>
        <CallsTable hidePagination hideSearch limit={5} variant="embedded" />
      </CardContent>
    </Card>
  );
}
